import _ from 'lodash'
import Layout from "@/layout/Layout";
import globalStyle from '@/styles/Global.scss'
import React, {useEffect, useState} from "react";
import {getScheduleList} from "@/api/schedule";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";
import ScheduleView from "@/components/schedule/ScheduleView";
import {rangeOf} from "@/util/util";
import dayjs from "dayjs";
import { Schedule as ScheduleModel } from '@/entity/Schedule';

const Schedule = () => {
  const history = useHistory()
  const [dateStart, setDateStart] = useState(0)
  const [dateOffset, setDateOffset] = useState(30)
  const [schedules, setSchedules] = useState([])

  useEffect(() => {
    (async () => {
      await loadSchedules()
    })()
  }, [])

  const toMenu = () => {
    history.push(`/menu`)
  }

  const loadSchedules = async () => {
    const schedules = await getScheduleList()
    setSchedules(schedules)
  }

  const todaySchedule = ({offset}) => {
    const targetDate = dayjs().subtract(offset, 'day')
    const formatTargetDate = targetDate.format('YYYY-MM-DD')
    return _.filter(schedules, (s) => { return formatTargetDate === s.formatedDate() })[0]
      || new ScheduleModel({ date: targetDate.toDate() })
  }

  const makeDateOffsets = () => {
    return _.map(rangeOf(dateOffset), (r) => {return r + dateStart})
  }

  return (
    <>
      <Layout category={'UK'} title={'スケジュール'}>
        <div className={globalStyle.container}>
          <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
          <h3>スケジュール</h3>
          <span className={globalStyle.link} onClick={() => { setDateStart(dateStart - 30) }}>今後の30日を表示</span>
          {
            _.map(makeDateOffsets(), (offset) => {
              return <React.Fragment key={offset}>
                <ScheduleView schedule={todaySchedule({offset})}></ScheduleView>
              </React.Fragment>
            })
          }
          <span className={globalStyle.link} onClick={() => { setDateOffset(dateOffset + 30) }}>以前の30日を表示</span>
        </div>
      </Layout>
    </>
  )
}

export default Schedule
